module.exports = __webpack_public_path__ + "img/no-notify-icon1.085f71dd.png";